import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";
import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";

import {red700} from "assets/jss/main";

import store from "store";

GlobalMissedRevenue.propTypes = {
    revenue: PropTypes.number
};

function GlobalMissedRevenue({revenue}) {
    const currentOrganization = store.getState()?.currentOrganization?.retrieved;

    return (
        <Badge
            color={'error'}
            labelColor={red700}
            border
            isBold={false}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <FormattedMessage id='product.show.stockAlert.globalMissedRevenue'/>
                &nbsp;
                <FormattedNumberWithCurrency value={revenue} currency={currentOrganization?.currency} />
                <span style={{marginLeft: '4px', display: 'flex'}}>
                    <InfoTooltipIcon color={red700} titleId={'product.show.stockAlert.globalMissedRevenue.tooltip'} />
                </span>
            </div>
        </Badge>
    );
}

export default GlobalMissedRevenue;
